export default __webpack_public_path__ + "static/media/toilet-paper.c6bf8b88.svg";